import { GlobalWorkerOptions } from 'pdfjs-dist'

// Vite (Rollup) natively understands `new URL(..., import.meta.url)` as an
// asset reference: it copies the worker file into the build output and
// rewrites this to the correct hashed URL, in both dev and prod. This is
// pdf.js's own recommended approach for modern bundlers and needs no extra
// webpack/CRA-style worker configuration (public/ copy, postinstall script,
// etc) — verified end-to-end against a real PDF via the dev server.
//
// Shared by every module that touches pdfjs-dist (extractPdfText,
// renderPdfThumbnail) so the worker is only configured once.
GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString()
